module.exports = __webpack_public_path__ + "media/images/yellow_ball-ef171f42709bfdae7d7cf16e8301b177.png";